export default [
  {
    title: 'Online Store',
    customicon: `<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z" stroke="#222222" stroke-width="1.5"/>
      <path d="M7 8L17 8" stroke="#222222" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M7 12L17 12" stroke="#222222" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M7 16L12 16" stroke="#222222" stroke-width="1.5" stroke-linecap="round"/>
    </svg>`,
    resource: 'Komstore',
    action: 'manage',
    children: [
      // {
      //   title: 'Desain Website',
      //   icon: 'None',
      //   route: 'online-store-design',
      //   resource: 'Komstore',
      //   action: 'manage',
      // },
      {
        title: 'Manajemen Toko',
        icon: 'None',
        route: 'online-store-management',
        resource: 'Komstore',
        action: 'manage',
      },
      // {
      //   title: 'Domain & SEO',
      //   icon: 'None',
      //   route: 'online-store-domain-seo',
      //   resource: 'Komstore',
      //   action: 'manage',
      // },
    ],
  },
]
